module.exports = __webpack_public_path__ + "assets/img/marketplace-image.09f9fd26.jpg";